<template>
  <div style="cursor: pointer">
    <label :style="labelStyle" class="d-picture-select d-f-r d-fa-c" :class="stateClass">
      <input
          ref="file-input"
          type="file"
          style="display: none"
          :accept="accept"
          @change="handleChange"
      />
      <span v-if="value" class="d-f-r d-f-1 d-fa-c" style="width: 0">
        <span v-if="value.fileName" class="d-f-1 text-line-1">{{ value.fileName }}</span>
        <span v-if="text" class="d-f-1 text-line-1">{{ text }}</span>
      </span>
      <span v-else>{{ placeholder }}</span>
    </label>
    <span v-if="message" class="text-danger">{{ message }}</span>
  </div>
</template>

<script>
import FileMixin from "@/mixins/FileMixin";

export default {
  name: 'FilePicker',
  props: {
    accept: {
      type: String, default: null
    },
    placeholder: {
      type: String, default: "Select file"
    },
    name: String,
    label: String,
    text: String,
    labelStyle: String,
    value: {
      default: null,
    },
    multiple: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: Array
    }
  },
  mixins: [FileMixin],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    message() {
      return this.errors && this.errors.length > 0 ? this.errors.join(", ") : null
    },
    stateClass() {
      return this.message === null
          ? 'd-input-info'
          : !this.message
              ? 'd-input-success'
              : 'd-input-error'
    },
  },
  methods: {
    async handleChange(files) {
      const res = await this.upload(files)
      this.$emit('input', res)
    }
  }
};
</script>
<style scoped>
.d-picture-select {
  border-radius: 4px;
  width: 100%;
}

.d-input-error {
  border: 1px solid #F64E60 !important;
}

.d-input-success {
  border: 1px solid #1BC5BD !important;
}

.d-input-info {
  border: 1px solid #E4E6EF !important;
}
</style>


